<template><div><h1>使用谷歌统计</h1>
<p>单页面应用切换时要手动发送页面统计，首先在 <code>index.html</code> 或者  <code>main.js</code> 里引入谷歌统计代码：</p>
<pre class="hljs"><code>(<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">i,s,o,g,r,a,m</span>)</span>{i[<span class="hljs-string">'GoogleAnalyticsObject'</span>]=r;i[r]=i[r]||<span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params"></span>)</span>{
(i[r].q=i[r].q||[]).push(<span class="hljs-built_in">arguments</span>)},i[r].l=<span class="hljs-number">1</span>*<span class="hljs-keyword">new</span> <span class="hljs-built_in">Date</span>();a=s.createElement(o),
m=s.getElementsByTagName(o)[<span class="hljs-number">0</span>];a.async=<span class="hljs-number">1</span>;a.src=g;m.parentNode.insertBefore(a,m)
})(<span class="hljs-built_in">window</span>,<span class="hljs-built_in">document</span>,<span class="hljs-string">'script'</span>,<span class="hljs-string">'https://www.google-analytics.com/analytics.js'</span>,<span class="hljs-string">'ga'</span>);

ga(<span class="hljs-string">'create'</span>, <span class="hljs-string">'UA-yourID'</span>, <span class="hljs-string">'auto'</span>)
ga(<span class="hljs-string">'send'</span>, <span class="hljs-string">'pageview'</span>) <span class="hljs-comment">// 是否要统计着陆页面访问，取决于你的需求，这个不一定需要，会和`router`统计有重复</span>

</code></pre>
<pre class="hljs"><code><span class="hljs-comment">// main.js 里，如果你使用了 vue-router</span>
router.afterEach(<span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">to</span>) </span>{
  <span class="hljs-keyword">if</span> (<span class="hljs-built_in">window</span>.ga) {
    <span class="hljs-built_in">window</span>.ga(<span class="hljs-string">'set'</span>, <span class="hljs-string">'page'</span>, to.fullPath) <span class="hljs-comment">// 你可能想根据请求参数添加其他参数，可以修改这里的 to.fullPath</span>
    <span class="hljs-built_in">window</span>.ga(<span class="hljs-string">'send'</span>, <span class="hljs-string">'pageview'</span>)
  }
})
</code></pre>
</div></template><script>
export default {
  head: {"title":"Vue 中使用谷歌统计 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-google-analytics-438.vue?3e0cd4fe